import { render, staticRenderFns } from "./GlobalSnackbar.vue?vue&type=template&id=9a641c6e&scoped=true&"
import script from "./GlobalSnackbar.vue?vue&type=script&setup=true&lang=ts&"
export * from "./GlobalSnackbar.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./GlobalSnackbar.vue?vue&type=style&index=0&id=9a641c6e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a641c6e",
  null
  
)

export default component.exports